module.exports = __webpack_public_path__ + "a17d279f/img/file-icon.c085e21e.svg";